export const safeList = [
  // Colors for light theme
  'text-forground',
  'text-primary',
  'text-secondary',
  'text-success',
  'text-warning',
  'text-danger',
  'text-light',
  'text-dark',
  'bg-background',
  'bg-primary',
  'bg-secondary',
  'bg-success',
  'bg-warning',
  'bg-danger',
  'bg-light',
  'bg-dark',
  'border-primary',
  'border-secondary',
  'border-success',
  'border-warning',
  'border-danger',
  'border-light',
  'border-dark',

  // Colors for dark theme
  'dark:text-forground',
  'dark:text-primary',
  'dark:text-secondary',
  'dark:text-success',
  'dark:text-warning',
  'dark:text-danger',
  'dark:text-light',
  'dark:text-dark',
  'dark:bg-background',
  'dark:bg-primary',
  'dark:bg-secondary',
  'dark:bg-success',
  'dark:bg-warning',
  'dark:bg-danger',
  'dark:bg-light',
  'dark:bg-dark',
  'dark:border-primary',
  'dark:border-secondary',
  'dark:border-success',
  'dark:border-warning',
  'dark:border-danger',
  'dark:border-light',
  'dark:border-dark',
  // Tailwind CSS default color palette
  'bg-red-50', 'bg-red-100', 'bg-red-200', 'bg-red-300', 'bg-red-400', 'bg-red-500', 'bg-red-600', 'bg-red-700', 'bg-red-800', 'bg-red-900',
  'bg-yellow-50', 'bg-yellow-100', 'bg-yellow-200', 'bg-yellow-300', 'bg-yellow-400', 'bg-yellow-500', 'bg-yellow-600', 'bg-yellow-700', 'bg-yellow-800', 'bg-yellow-900',
  'bg-green-50', 'bg-green-100', 'bg-green-200', 'bg-green-300', 'bg-green-400', 'bg-green-500', 'bg-green-600', 'bg-green-700', 'bg-green-800', 'bg-green-900',
  'bg-blue-50', 'bg-blue-100', 'bg-blue-200', 'bg-blue-300', 'bg-blue-400', 'bg-blue-500', 'bg-blue-600', 'bg-blue-700', 'bg-blue-800', 'bg-blue-900',
  'bg-indigo-50', 'bg-indigo-100', 'bg-indigo-200', 'bg-indigo-300', 'bg-indigo-400', 'bg-indigo-500', 'bg-indigo-600', 'bg-indigo-700', 'bg-indigo-800', 'bg-indigo-900',
  'bg-purple-50', 'bg-purple-100', 'bg-purple-200', 'bg-purple-300', 'bg-purple-400', 'bg-purple-500', 'bg-purple-600', 'bg-purple-700', 'bg-purple-800', 'bg-purple-900',
  'bg-pink-50', 'bg-pink-100', 'bg-pink-200', 'bg-pink-300', 'bg-pink-400', 'bg-pink-500', 'bg-pink-600', 'bg-pink-700', 'bg-pink-800', 'bg-pink-900',
  'bg-gray-50', 'bg-gray-100', 'bg-gray-200', 'bg-gray-300', 'bg-gray-400', 'bg-gray-500', 'bg-gray-600', 'bg-gray-700', 'bg-gray-800', 'bg-gray-900',

  // Tailwind CSS default color palette for dark theme
  'dark:bg-red-50', 'dark:bg-red-100', 'dark:bg-red-200', 'dark:bg-red-300', 'dark:bg-red-400', 'dark:bg-red-500', 'dark:bg-red-600', 'dark:bg-red-700', 'dark:bg-red-800', 'dark:bg-red-900',
  'dark:bg-yellow-50', 'dark:bg-yellow-100', 'dark:bg-yellow-200', 'dark:bg-yellow-300', 'dark:bg-yellow-400', 'dark:bg-yellow-500', 'dark:bg-yellow-600', 'dark:bg-yellow-700', 'dark:bg-yellow-800', 'dark:bg-yellow-900',
  'dark:bg-green-50', 'dark:bg-green-100', 'dark:bg-green-200', 'dark:bg-green-300', 'dark:bg-green-400', 'dark:bg-green-500', 'dark:bg-green-600', 'dark:bg-green-700', 'dark:bg-green-800', 'dark:bg-green-900',
  'dark:bg-blue-50', 'dark:bg-blue-100', 'dark:bg-blue-200', 'dark:bg-blue-300', 'dark:bg-blue-400', 'dark:bg-blue-500', 'dark:bg-blue-600', 'dark:bg-blue-700', 'dark:bg-blue-800', 'dark:bg-blue-900',
  'dark:bg-indigo-50', 'dark:bg-indigo-100', 'dark:bg-indigo-200', 'dark:bg-indigo-300', 'dark:bg-indigo-400', 'dark:bg-indigo-500', 'dark:bg-indigo-600', 'dark:bg-indigo-700', 'dark:bg-indigo-800', 'dark:bg-indigo-900',
  'dark:bg-purple-50', 'dark:bg-purple-100', 'dark:bg-purple-200', 'dark:bg-purple-300', 'dark:bg-purple-400', 'dark:bg-purple-500', 'dark:bg-purple-600', 'dark:bg-purple-700', 'dark:bg-purple-800', 'dark:bg-purple-900',
  'dark:bg-pink-50', 'dark:bg-pink-100', 'dark:bg-pink-200', 'dark:bg-pink-300', 'dark:bg-pink-400', 'dark:bg-pink-500', 'dark:bg-pink-600', 'dark:bg-pink-700', 'dark:bg-pink-800', 'dark:bg-pink-900',
  'dark:bg-gray-50', 'dark:bg-gray-100', 'dark:bg-gray-200', 'dark:bg-gray-300', 'dark:bg-gray-400', 'dark:bg-gray-500', 'dark:bg-gray-600', 'dark:bg-gray-700', 'dark:bg-gray-800', 'dark:bg-gray-900',

  'grid',
  'grid-cols-1',
  'grid-cols-2',
  'grid-cols-3',
  'grid-cols-4',
  'grid-cols-5',
  'grid-cols-6',
  'grid-cols-7',
  'grid-cols-8',
  'grid-cols-9',
  'grid-cols-10',
  'grid-cols-11',
  'grid-cols-12',
  'sm:grid-cols-1',
  'sm:grid-cols-2',
  'sm:grid-cols-3',
  'sm:grid-cols-4',
  'sm:grid-cols-5',
  'sm:grid-cols-6',
  'sm:grid-cols-7',
  'sm:grid-cols-8',
  'sm:grid-cols-9',
  'sm:grid-cols-10',
  'sm:grid-cols-11',
  'sm:grid-cols-12',
  'md:grid-cols-1',
  'md:grid-cols-2',
  'md:grid-cols-3',
  'md:grid-cols-4',
  'md:grid-cols-5',
  'md:grid-cols-6',
  'md:grid-cols-7',
  'md:grid-cols-8',
  'md:grid-cols-9',
  'md:grid-cols-10',
  'md:grid-cols-11',
  'md:grid-cols-12',
  'lg:grid-cols-1',
  'lg:grid-cols-2',
  'lg:grid-cols-3',
  'lg:grid-cols-4',
  'lg:grid-cols-5',
  'lg:grid-cols-6',
  'lg:grid-cols-7',
  'lg:grid-cols-8',
  'lg:grid-cols-9',
  'lg:grid-cols-10',
  'lg:grid-cols-11',
  'lg:grid-cols-12',
  'xl:grid-cols-1',
  'xl:grid-cols-2',
  'xl:grid-cols-3',
  'xl:grid-cols-4',
  'xl:grid-cols-5',
  'xl:grid-cols-6',
  'xl:grid-cols-7',
  'xl:grid-cols-8',
  'xl:grid-cols-9',
  'xl:grid-cols-10',
  'xl:grid-cols-11',
  'xl:grid-cols-12',
  'w-0',
  'w-1',
  'w-2',
  'w-3',
  'w-4',
  'w-5',
  'w-6',
  'w-7',
  'w-8',
  'w-9',
  'w-10',
  'w-11',
  'w-12',
  'w-14',
  'w-16',
  'w-20',
  'w-24',
  'w-28',
  'w-32',
  'w-36',
  'w-40',
  'w-44',
  'w-48',
  'w-52',
  'w-56',
  'w-60',
  'w-64',
  'w-72',
  'w-80',
  'w-96',
  'w-auto',
  'w-px',
  'w-1/2',
  'w-1/3',
  'w-2/3',
  'w-1/4',
  'w-2/4',
  'w-3/4',
  'w-1/5',
  'w-2/5',
  'w-3/5',
  'w-4/5',
  'w-1/6',
  'w-2/6',
  'w-3/6',
  'w-4/6',
  'w-5/6',
  'w-screen',
  'w-full',
  'sm:w-0',
  'sm:w-1',
  'sm:w-2',
  'sm:w-3',
  'sm:w-4',
  'sm:w-5',
  'sm:w-6',
  'sm:w-7',
  'sm:w-8',
  'sm:w-9',
  'sm:w-10',
  'sm:w-11',
  'sm:w-12',
  'sm:w-14',
  'sm:w-16',
  'sm:w-20',
  'sm:w-24',
  'sm:w-28',
  'sm:w-32',
  'sm:w-36',
  'sm:w-40',
  'sm:w-44',
  'sm:w-48',
  'sm:w-52',
  'sm:w-56',
  'sm:w-60',
  'sm:w-64',
  'sm:w-72',
  'sm:w-80',
  'sm:w-96',
  'sm:w-auto',
  'sm:w-px',
  'sm:w-1/2',
  'sm:w-1/3',
  'sm:w-2/3',
  'sm:w-1/4',
  'sm:w-2/4',
  'sm:w-3/4',
  'sm:w-1/5',
  'sm:w-2/5',
  'sm:w-3/5',
  'sm:w-4/5',
  'sm:w-1/6',
  'sm:w-2/6',
  'sm:w-3/6',
  'sm:w-4/6',
  'sm:w-5/6',
  'sm:w-screen',
  'sm:w-full',
  'md:w-0',
  'md:w-1',
  'md:w-2',
  'md:w-3',
  'md:w-4',
  'md:w-5',
  'md:w-6',
  'md:w-7',
  'md:w-8',
  'md:w-9',
  'md:w-10',
  'md:w-11',
  'md:w-12',
  'md:w-14',
  'md:w-16',
  'md:w-20',
  'md:w-24',
  'md:w-28',
  'md:w-32',
  'md:w-36',
  'md:w-40',
  'md:w-44',
  'md:w-48',
  'md:w-52',
  'md:w-56',
  'md:w-60',
  'md:w-64',
  'md:w-72',
  'md:w-80',
  'md:w-96',
  'md:w-auto',
  'md:w-px',
  'md:w-1/2',
  'md:w-1/3',
  'md:w-2/3',
  'md:w-1/4',
  'md:w-2/4',
  'md:w-3/4',
  'md:w-1/5',
  'md:w-2/5',
  'md:w-3/5',
  'md:w-4/5',
  'md:w-1/6',
  'md:w-2/6',
  'md:w-3/6',
  'md:w-4/6',
  'md:w-5/6',
  'md:w-screen',
  'md:w-full',
  'lg:w-0',
  'lg:w-1',
  'lg:w-2',
  'lg:w-3',
  'lg:w-4',
  'lg:w-5',
  'lg:w-6',
  'lg:w-7',
  'lg:w-8',
  'lg:w-9',
  'lg:w-10',
  'lg:w-11',
  'lg:w-12',
  'lg:w-14',
  'lg:w-16',
  'lg:w-20',
  'lg:w-24',
  'lg:w-28',
  'lg:w-32',
  'lg:w-36',
  'lg:w-40',
  'lg:w-44',
  'lg:w-48',
  'lg:w-52',
  'lg:w-56',
  'lg:w-60',
  'lg:w-64',
  'lg:w-72',
  'lg:w-80',
  'lg:w-96',
  'lg:w-auto',
  'lg:w-px',
  'lg:w-1/2',
  'lg:w-1/3',
  'lg:w-2/3',
  'lg:w-1/4',
  'lg:w-2/4',
  'lg:w-3/4',
  'lg:w-1/5',
  'lg:w-2/5',
  'lg:w-3/5',
  'lg:w-4/5',
  'lg:w-1/6',
  'lg:w-2/6',
  'lg:w-3/6',
  'lg:w-4/6',
  'lg:w-5/6',
  'lg:w-screen',
  'lg:w-full',
  'xl:w-0',
  'xl:w-1',
  'xl:w-2',
  'xl:w-3',
  'xl:w-4',
  'xl:w-5',
  'xl:w-6',
  'xl:w-7',
  'xl:w-8',
  'xl:w-9',
  'xl:w-10',
  'xl:w-11',
  'xl:w-12',
  'xl:w-14',
  'xl:w-16',
  'xl:w-20',
  'xl:w-24',
  'xl:w-28',
  'xl:w-32',
  'xl:w-36',
  'xl:w-40',
  'xl:w-44',
  'xl:w-48',
  'xl:w-52',
  'xl:w-56',
  'xl:w-60',
  'xl:w-64',
  'xl:w-72',
  'xl:w-80',
  'xl:w-96',
  'xl:w-auto',
  'xl:w-px',
  'xl:w-1/2',
  'xl:w-1/3',
  'xl:w-2/3',
  'xl:w-1/4',
  'xl:w-2/4',
  'xl:w-3/4',
  'xl:w-1/5',
  'xl:w-2/5',
  'xl:w-3/5',
  'xl:w-4/5',
  'xl:w-1/6',
  'xl:w-2/6',
  'xl:w-3/6',
  'xl:w-4/6',
  'xl:w-5/6',
  'xl:w-screen',
  'xl:w-full',
  'z-[99999]',
  'z-[9999]',
  'z-10',
  'z-20',
  'z-30',
  'z-auto',
  'z-50',
  'grid-cols-1', 'grid-cols-2', 'grid-cols-3', 'grid-cols-4', 'grid-cols-5', 'grid-cols-6',
  'grid-cols-7', 'grid-cols-8', 'grid-cols-9', 'grid-cols-10', 'grid-cols-11', 'grid-cols-12',
  'col-span-1', 'col-span-2', 'col-span-3', 'col-span-4', 'col-span-5', 'col-span-6',
  'col-span-7', 'col-span-8', 'col-span-9', 'col-span-10', 'col-span-11', 'col-span-12',
  'col-span-auto', 'col-span-content',
  'col-start-1', 'col-start-2', 'col-start-3', 'col-start-4', 'col-start-5', 'col-start-6',
  'col-start-7', 'col-start-8', 'col-start-9', 'col-start-10', 'col-start-11', 'col-start-12',
  'order-1', 'order-2', 'order-3', 'order-4', 'order-5', 'order-6',
  'order-7', 'order-8', 'order-9', 'order-10', 'order-11', 'order-12',
  'gap-xs', 'gap-sm', 'gap-md', 'gap-lg', 'gap-xl',
  'items-start', 'items-center', 'items-end', 'items-stretch', 'items-baseline',
  'justify-start', 'justify-center', 'justify-end', 'justify-between', 'justify-around', 'justify-evenly',
  'overflow-visible', 'overflow-hidden', 'overflow-scroll', 'overflow-auto',
  'grid-rows-1',
  // Responsive classes
  'col-span-base-1', 'col-span-base-2', 'col-span-base-3', 'col-span-base-4', 'col-span-base-5', 'col-span-base-6',
  'col-span-base-7', 'col-span-base-8', 'col-span-base-9', 'col-span-base-10', 'col-span-base-11', 'col-span-base-12',
  'col-span-xs-1', 'col-span-xs-2', 'col-span-xs-3', 'col-span-xs-4', 'col-span-xs-5', 'col-span-xs-6',
  'col-span-xs-7', 'col-span-xs-8', 'col-span-xs-9', 'col-span-xs-10', 'col-span-xs-11', 'col-span-xs-12',
  'col-span-sm-1', 'col-span-sm-2', 'col-span-sm-3', 'col-span-sm-4', 'col-span-sm-5', 'col-span-sm-6',
  'col-span-sm-7', 'col-span-sm-8', 'col-span-sm-9', 'col-span-sm-10', 'col-span-sm-11', 'col-span-sm-12',
  'col-span-md-1', 'col-span-md-2', 'col-span-md-3', 'col-span-md-4', 'col-span-md-5', 'col-span-md-6',
  'col-span-md-7', 'col-span-md-8', 'col-span-md-9', 'col-span-md-10', 'col-span-md-11', 'col-span-md-12',
  'col-span-lg-1', 'col-span-lg-2', 'col-span-lg-3', 'col-span-lg-4', 'col-span-lg-5', 'col-span-lg-6',
  'col-span-lg-7', 'col-span-lg-8', 'col-span-lg-9', 'col-span-lg-10', 'col-span-lg-11', 'col-span-lg-12',
  'col-span-xl-1', 'col-span-xl-2', 'col-span-xl-3', 'col-span-xl-4', 'col-span-xl-5', 'col-span-xl-6',
  'col-span-xl-7', 'col-span-xl-8', 'col-span-xl-9', 'col-span-xl-10', 'col-span-xl-11', 'col-span-xl-12',
  'dark',
  // Common utility classes
  'flex',
  'flex-row',
  'flex-col',
  'items-start',
  'items-center',
  'items-end',
  'justify-start',
  'justify-center',
  'justify-end',
  'justify-between',
  'justify-around',
  'justify-evenly',
  'space-x-1',
  'space-x-2',
  'space-x-3',
  'space-x-4',
  'space-x-6',
  'space-x-8',
  'space-y-1',
  'space-y-2',
  'space-y-3',
  'space-y-4',
  'space-y-6',
  'space-y-8',
  'p-1',
  'p-2',
  'p-3',
  'p-4',
  'p-6',
  'p-8',
  'm-1',
  'm-2',
  'm-3',
  'm-4',
  'm-6',
  'm-8',
  'w-full',
  'h-full',
  'rounded',
  'rounded-lg',
  'rounded-xl',
  'rounded-2xl',
  'rounded-3xl',
  'shadow',
  'shadow-md',
  'shadow-lg',
  'shadow-xl',
  'shadow-2xl',
  'border',
  'border-2',
  'border-4',
  'border-8',
];